import createSimpleComponent from '../createSimpleComponent'

import cls from './tag-container.module.scss'

export default createSimpleComponent({
  displayName: 'UikTagContainer',
  className: cls.wrapper,
  Component: 'div',
})
